import React, {Component} from 'react';
import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter, Table
} from 'reactstrap';
import {toast} from 'react-toastify';
import moment from 'moment';

import loadingGIF from "../../public/assets/images/loading.gif";
import ErrorMsg from "../common/ErrorMsg";
import {
    PTO_REQUEST_STATUS, PTO_REQUEST_STATUS_LIST, CANCELED, APPROVED, DENIED
} from "./Constants";
import PTORequestModal from "./PTORequestModal";
import ConfirmModal from "../common/ConfirmModal";
import SickLeaveService from "../../services/SickLeaveServices";

export default class RequestList extends Component {

    state = {
        selectedLocation: this.props.agencyLocation,
        selectedUser: 0,
        userList: [],
        isLoading: false,
        requestModal: false,
        selectedRequest: {
            requestObj: {},
            clear: true
        },
        year: this.props.year,
        selectedStatus: 0,
        confirmationModalData: {},
        selectedReason: 0,
        UserSickLeaveRequest:[]
    }
    
    componentDidMount = () => {
        const {agencyLocation, isStaff} = this.props;
        if(agencyLocation && !isStaff) {
            this.getUsers(this.props.agencyLocation);
            this.getDenialReasonList();
        }
        this.setState({
            selectedUser: this.props.selectedUser
        }, () => this.getRequests(this.state.selectedUser));
        return;
    }

    getDenialReasonList = async () => {
        try {
            await this.props.getPTOReasonList(this.props.agencyLocation);
        } catch (error) {
            toast.error(<ErrorMsg errors={error} />);
        }
    }

    changeLocation = (e) => {
        let selectedLocation = Number(e.target.value);
        this.setState({selectedLocation, selectedUser: 0});
        this.getUsers(selectedLocation);
    }

    getUsers = async (selectedLocation) => {
        this.setState({isLoading: true});
        try {
            let result = await this.props.getUserList(selectedLocation);
            if(result) {
                this.setState({userList: [...result]});
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
        this.setState({isLoading: false});
        return;
    }

    changeUser = (e) => {
        let selectedUser = Number(e.target.value);
        if (selectedUser) {
            this.setState({selectedUser, selectedStatus: 0});
            this.getRequests(selectedUser);
        }
    }

    changeYear = (e) => {
        this.setState({
            year: Number(e.target.value)
        }, () => this.getRequests(this.state.selectedUser));
    }

    renderYear = () => {
        let yearList = [];
        const currentYear = moment().year();

        for(let year=2018; year <= currentYear + 1; ++year) {
            yearList.push(
                <option key={year} value={year}>{year}</option>
            );
        }
        return yearList;
    }

    renderLocations = () => {
        return this.props.locationList.map(location => 
            <option key={location.id} value={location.id}>{location.name}</option>
        )
    }

    renderUsers = () => {
        return this.state.userList.map(user => 
            <option key={user.id} value={user.id}>{user.full_name}</option>
        )
    }

    getRequests = async (selectedUser) => {
        this.setState({isLoading: true});
        const {year} = this.state;
        if (selectedUser && year) {
            try {
                await this.props.getUserRequests(selectedUser, year);
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>);
            }
            try {
                const resultSL = await SickLeaveService.getUserSickLeaveRequests(selectedUser, year)
            this.setState({UserSickLeaveRequest:resultSL.data})
            } catch (error) {
                    toast.error(<ErrorMsg errors={error}/>);
            }
        }
        this.setState({isLoading: false});
        return;
    }

    openRequestModal = (requestObj={}, clear=true) => {
        if (this.state.selectedUser) {
            console.log(requestObj);
            let start = moment(requestObj.start_date, "MM/DD/YYYY");
            let end = moment(requestObj.end_date, "MM/DD/YYYY");
            let is_paid = requestObj.is_paid;
            console.log(is_paid);
            this.setState({
                selectedRequest: {
                    requestObj: {...requestObj, start, end, is_paid},
                    clear
                },
                requestModal: true, 
                
            });
        }
    }

    closeRequestModal = () => {
        this.setState({
            requestModal: false,
            selectedRequest: {
                requestObj: {},
                clear: true
            }
        });
        this.getRequests(this.state.selectedUser);
    }

    changeReason = (e) => {
        let value = Number(e.target.value);
        if (value) {
            this.setState({selectedReason: value});
        }
    }

    openDenialConfirmation = (request) => {
        const {selectedReason} = this.state;
        let showConfirmModal = true, size="sm", hide=this.closeConfirmationModal;
        let msgTitle = "Choose Reason";
        let msgBody = <React.Fragment>
            <label className="mb-1">Please select a reason for denial</label>
            <select className="form-control"
                value={selectedReason}
                onChange={this.changeReason}
            >
                {this.props.pto.reasonList.map((reason) => 
                    <option key={reason.id} value={reason.id}>{reason.reason}</option>
                )}
            </select>
        </React.Fragment> 
        let buttons = [
            {
                className: "btn btn-success",
                onClick: () => this.submitRequest(request, DENIED),
                label: "Submit"
            },
            {
                className: "btn btn-default",
                onClick: this.closeConfirmationModal,
                label: "Close"
            }
        ];
        this.setState({
            confirmationModalData: {
                showConfirmModal, size, hide, msgTitle,
                msgBody, buttons
            }
        });
        return false;
    }

    openApproveConfirmation = (request) => {
        let showConfirmModal = true, size="sm", hide=this.closeConfirmationModal;
        let msgTitle = "Confirmation!";
        let msgBody = <p>Are you sure, You want to approve the time off request?</p>;
        let buttons = [
            {
                className: "btn btn-success",
                onClick: () => this.submitRequest(request, APPROVED),
                label: "Yes"
            },
            {
                className: "btn btn-default",
                onClick: this.closeConfirmationModal,
                label: "No"
            }
        ];
        this.setState({
            confirmationModalData: {
                showConfirmModal, size, hide, msgTitle,
                msgBody, buttons
            }
        });
        return false;
    }

    // change status to approved / denied 
    submitRequest = async (request, status) => {
        this.setState({isLoading: true});
        try {
            const {reasonList} = this.props.pto;
            const {selectedReason, selectedUser} = this.state;
            let updatedRequestObj = {...request, status, deny_reason: selectedReason};
            if (status === DENIED) {
                if (!updatedRequestObj.deny_reason) {
                    updatedRequestObj.deny_reason = reasonList.length ? reasonList[0].id : null
                } 
            } else {
                updatedRequestObj.deny_reason = null;
            }
            const result = await this.props.updatePendingRequestData(updatedRequestObj);
            if (result) {
                toast.success("Status changed successfully.");
                this.getRequests(selectedUser);
                this.props.refreshPTOInfos();
            }
        } catch(error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
        this.setState({isLoading: false});
    }

    openDeleteConfirmation = (request) => {
        let showConfirmModal = true, size="sm", hide=this.closeConfirmationModal;
        let msgTitle = "Confirmation!";
        let msgBody = <p>Are you sure, you want to cancel this request?</p>
        let buttons = [
            {
                className: "btn btn-danger",
                onClick: () => this.deleteRequest(request),
                label: "Yes"
            },
            {
                className: "btn btn-default",
                onClick: this.closeConfirmationModal,
                label: "No"
            }
        ];
        this.setState({
            confirmationModalData: {
                showConfirmModal, size, hide, msgTitle, msgBody, buttons
            }
        });
        return false;
    }

    deleteRequest = async (request) => {
        this.setState({isLoading: true});
        try {
            const result = await this.props.TimeOffRequest(request, "DELETE");

            if (result) {
                toast.success("Request has been canceled successfully.");
                this.getRequests(this.state.selectedUser);
                this.props.refreshPTOInfos();
            }
        } catch(error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
        this.setState({isLoading: false});
    }

    closeConfirmationModal = () => {
        this.setState({
            confirmationModalData: {
                ...this.state.confirmationModalData, showConfirmModal: false
            }
        });
    }

    changeStatus = (request, e) => {
        let status = Number(e.target.value);

        if (status === APPROVED) {
            this.openApproveConfirmation(request);
        } else if (status === DENIED) {
            this.openDenialConfirmation(request);
        } else if (status === CANCELED) {
            this.openDeleteConfirmation(request);
        }
    }
    
    renderRequests = () => { 
        const {isStaff} = this.props;
        const {selectedStatus} = this.state;
        let requestList = []; 
        const today = moment();
        this.props.pto.userRequestList.map(request => {
            if (selectedStatus === 0 || request.status === selectedStatus) {
                requestList.push(
                    <tr key={request.id}>
                        <td className="align-middle" title="Modify/Cancel Request">
                            {isStaff ? request.time_off_name :
                                <a className="kb-link-item text-info" 
                                    onClick={() => this.openRequestModal(request, false)}
                                >
                                    {request.time_off_name}
                                </a>
                            }
                        </td>
                        <td className="align-middle">{request.start_date}</td>
                        <td className="align-middle">{request.end_date}</td>
                        <td className="align-middle">
                            {request.total_time_off} {
                                request.is_pto_in_hour ? "hour" : "day"
                            }{request.total_time_off > 1 ? 's' : ''}
                        </td>
                        
                        <td className="align-middle text-center">
                            {request.is_paid ? 
                                <i className="fa fa-check-circle text-success"></i>
                                : ''
                            }
                        </td>
                        <td className="align-middle">
                            {/* {!isStaff && moment(request.end_date) >= today ? */}
                                <select className="form-control form-control-sm"
                                    value={request.status}
                                    onChange={(e) => this.changeStatus(request, e)}
                                    title="Change Status"
                                >
                                    <option value={1} disabled={true}>
                                        Waiting for Approval
                                    </option>
                                    <option value={2} disabled={request.status === CANCELED}>
                                        Canceled
                                    </option>
                                    <option value={3} disabled={request.status === APPROVED}>
                                        Approved
                                    </option>
                                    <option value={4} disabled={request.status === DENIED}>
                                        Denied
                                    </option>
                                </select>
                                {/* : <span>{PTO_REQUEST_STATUS[request.status]} </span> */}
                            {/* } */}
                        </td>
                        <td className="align-middle">{request.response_date}</td>
                        <td className="align-middle">{request.responded_by_name}</td>
                        <td className="align-middle">{request.reason}</td>
                    </tr>
                )
                
                return true;
            } 
            return false;
        });
        this.state.UserSickLeaveRequest.map(SLrequest => {
            if (selectedStatus === 0 || SLrequest.status === selectedStatus) {
                requestList.push(
                    <tr key={SLrequest.id}>
                        <td className="align-middle" title="Modify/Cancel Request">
                            
                                <a className="kb-link-item text-info" 
                                    onClick={() => this.openRequestModal(SLrequest, false)}>
                                    Sick leave
                                </a>
                            
                        </td>
                        <td className="align-middle">{SLrequest.start_date}</td>
                        <td className="align-middle">{SLrequest.end_date}</td>
                        <td className="align-middle">
                            {SLrequest.total_time_off} hours
                        </td>
                        <td className="align-middle text-center">
                            
                                <i className="fa fa-check-circle text-success"></i>
                                
                            
                        </td>
                        <td className="align-middle">
                            {!isStaff && moment(SLrequest.end_date) >= today ?
                                <select className="form-control form-control-sm"
                                    value={SLrequest.status}
                                    onChange={(e) => this.changeStatus(SLrequest, e)}
                                    title="Change Status" disabled  
                                >
                                    <option value={1} disabled={true}>
                                        Waiting for Approval
                                    </option>
                                    <option value={2} disabled={SLrequest.status === CANCELED}>
                                        Canceled
                                    </option>
                                    <option value={3} disabled={SLrequest.status === APPROVED}>
                                        Approved
                                    </option>
                                    <option value={4} disabled={SLrequest.status === DENIED}>
                                        Denied
                                    </option>
                                </select>
                                : <span>{PTO_REQUEST_STATUS[SLrequest.status]} </span>
                            }
                        </td>
                        <td className="align-middle">{SLrequest.response_date}</td>
                        <td className="align-middle">{SLrequest.responded_by_name}</td>
                        <td className="align-middle">{SLrequest.reason}</td>
                    </tr>
                )
                
                return true;
            } 
            return false;
        });
        return requestList;
    }

    render() {
        const {
            selectedLocation, selectedUser, isLoading, confirmationModalData,
            requestModal, selectedRequest, year, selectedStatus, userList
        } = this.state;
        const {modal, toggleModal, locationList, isStaff, permission} = this.props;
        const currentYear = moment().year();
        let hireDate,job_profile;
        for(let i=0 ; i < userList.length ; i ++){
            if (this.state.selectedUser === userList[i].id){
                hireDate =  userList[i].hire_date 
                job_profile = userList[i].job_profile
            }
        }

        return (
            <Modal isOpen={modal} size={"lg"} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    Time off Request List
                </ModalHeader>
                <ModalBody>
                    <div className="row mb-3">
                        {(locationList.length > 1 && !isStaff) && 
                            <div className="col-sm-3">
                                <label className="mb-0">Select Agency Location</label>
                                <select className="form-control"
                                    value={selectedLocation}
                                    onChange={this.changeLocation}
                                >
                                    {this.renderLocations()}
                                </select>
                            </div>
                        }
                        <div className="col-sm-2">
                            <label className="mb-0">Select Year</label>
                            <select name="year" value={year} 
                                className="form-control"
                                onChange={this.changeYear}
                            >
                                {this.renderYear()}
                            </select>
                        </div>
                        {!isStaff && 
                            <div className="col-sm-3">
                                <label className="mb-0">Select User</label>
                                <select className="form-control"
                                    value={selectedUser}
                                    onChange={this.changeUser}
                                >
                                    <option key={0} value={0}>Select User</option>
                                    {this.renderUsers()}
                                </select>
                                {isLoading && 
                                    <p className="loading-gif">
                                        <img src={loadingGIF} alt="Loading..." 
                                            width="32" height="32"
                                        />
                                    </p>
                                }
                            </div>
                        }
                        {!isStaff && 
                            <div className="col-sm-2">
                                <label className="mb-0">Job Profile</label>
                                <input type="text" maxLength={50}
                                    value={job_profile}
                                    className="form-control" 
                                />
                                {isLoading && 
                                    <p className="loading-gif">
                                        <img src={loadingGIF} alt="Loading..." 
                                            width="32" height="32"
                                        />
                                    </p>
                                }
                            </div>
                        }
                        {!isStaff && 
                            <div className="col-sm-2">
                                <label className="mb-0">Hire Date</label>
                                <input type="text" maxLength={50}
                                    value={hireDate}
                                    className="form-control" 
                                />
                                {isLoading && 
                                    <p className="loading-gif">
                                        <img src={loadingGIF} alt="Loading..." 
                                            width="32" height="32"
                                        />
                                    </p>
                                }
                            </div>
                        }
                         

                    </div>
                    <Table hover striped size="sm">
                        <thead>
                            <tr>
                                <th className="align-middle">Type</th>
                                <th className="align-middle">Start Date</th>
                                <th className="align-middle">End Date</th>
                                <th className="align-middle">Timeoff</th>
                                <th className="align-middle text-center">Paid</th>
                                <th style={{width: "180px"}} className="align-middle">
                                    <div className="d-flex justify-content-between 
                                        align-items-center"
                                    >
                                        <span style={{width: "80px"}}>Status</span>
                                        {selectedLocation && selectedUser ? 
                                            <select value={selectedStatus}
                                                onChange={(e) => this.setState({
                                                    selectedStatus: Number(e.target.value)
                                                })}
                                                className="form-control form-control-sm"
                                            >
                                                {PTO_REQUEST_STATUS_LIST.map((status, index) => 
                                                    <option value={status.value} key={index}>
                                                        {status.status}
                                                    </option>
                                                )}
                                            </select>: null
                                        }
                                    </div>
                                </th>
                                <th className="align-middle">Response Date</th>
                                <th className="align-middle">Responded by</th>
                                <th className="align-middle">Reason</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedLocation && selectedUser ? this.renderRequests() : null}
                        </tbody>
                    </Table>
                    {isLoading && 
                        <p className="loading-gif">
                            <img src={loadingGIF} alt="Loading..." 
                                width="32" height="32"
                            />
                        </p>
                    }
                    {requestModal && 
                        <PTORequestModal {...this.props}
                            modal={requestModal} 
                            toggleModal={this.closeRequestModal}
                            selectedPTORequest={selectedRequest}
                            selectedUser={selectedUser}
                        />
                    }
                    {confirmationModalData.showConfirmModal &&
                        <ConfirmModal {...confirmationModalData} />
                    }
                </ModalBody>
                <ModalFooter>
                    {(permission && permission.can_add) && (
                        selectedUser && currentYear <= year && !isStaff
                    ) ?
                        <Button color="info" 
                            onClick={() => this.openRequestModal({}, true)}
                        >
                            Add Request
                        </Button>
                        : null
                    }
                    <Button color="secondary" onClick={toggleModal}>Close</Button>
                </ModalFooter>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pto/RequestListModal.js